'use strict';

exports.__esModule = true;
exports['default'] = getInitialState;

var _tournaments = require('./tournaments');

var _teams = require('./teams');

function getInitialState(panelProps) {
  return {
    tournaments: _tournaments.reducer(),
    teams: _teams.reducer()
  };
}

module.exports = exports['default'];